<div class="newsletter-wrapper">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="rts-cta-wrapper">
          <div class="background-cta">

            <app-toaster *ngIf="showToast" [message]="toastMessage" [type]="toastType"></app-toaster>

            <div class="row">
              <!-- cta-left -->
              <div class="col-lg-6">
                <div class="cta-left-wrapepr">
                  <p class="cta-disc">{{"NEWSLETTER.TITLE1" | translate}}</p>
                  <h3 class="title">{{"NEWSLETTER.SUBSCRIBETEXT" | translate}}</h3>
                </div>
              </div>
              <!-- cta left end -->
              <div class="col-lg-6">
                <!-- cta right -->
                <form class="cta-input-arae" #newsletterForm="ngForm" (ngSubmit)="onSubmit(newsletterForm)">
                  <input type="email" name="email" [(ngModel)]="email" placeholder="{{'NEWSLETTER.EMAIL' | translate}}"
                    required />
                  <button type="submit" class="rts-btn btn-primary">{{"NEWSLETTER.SUBSCRIBE" | translate}}</button>
                </form>
                <!-- cta right End -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>